import React, { useEffect, ReactNode } from 'react';
import { PageError, PageErrorType } from 'pages/page-error';
import { Loading } from 'components/block/loading';
import { useTranslation } from 'react-i18next';
import Breadcrumb, { Page } from 'components/block/breadcrumb/breadcrumb.component';
import { Link } from 'react-router-dom';

export enum InitPageStatus {
  RUNNING,
  OK,
  FAIL,
  CUSTOM_ERROR,
}

interface IPageWrapper {
  title: string;
  children: ReactNode;
  className?: string;
  initPageStatus?: InitPageStatus;
  documentTitle?: string;
  customPageErrorType?: PageErrorType;
  rightHeadingBlock?: ReactNode;
  leftHeadingBlock?: ReactNode;
  footerBlock?: ReactNode;
  pages?: Page[];
}

function PageWrapper({
  title,
  className,
  children,
  initPageStatus = InitPageStatus.OK,
  documentTitle,
  customPageErrorType,
  rightHeadingBlock,
  leftHeadingBlock,
  footerBlock,
  pages = [],
}: IPageWrapper) {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${documentTitle || title} | Intalent`;
  }, [title, documentTitle]);

  if (initPageStatus === InitPageStatus.RUNNING) {
    return <Loading />;
  }

  if (initPageStatus === InitPageStatus.FAIL) {
    return <PageError error={PageErrorType.PAGE_LOAD_FAILED} />;
  }

  if (initPageStatus === InitPageStatus.CUSTOM_ERROR) {
    return <PageError error={customPageErrorType} />;
  }

  return (
    <div className={className ? `content-wrapper ${className}` : 'content-wrapper'}>
      {pages.length > 0 ? (
        <div>
          <Breadcrumb pages={pages} />
        </div>
      ) : (
        title !== t('page.home.list.title') && (
          <div className=''>
            <ol className='breadcrumb h-my-0'>
              <Link to='/' className='breadcrumb-item'>
                {t('page.home.list.title')}
              </Link>
              <li className='breadcrumb-item active'>{title}</li>
            </ol>
          </div>
        )
      )}

      {/* Content Header */}
      <section className='content-header'>
        <div className='container-fluid'>
          <div className='row mb-2'>
            <div className='col-sm-6'>
              <h1>{title}</h1>
              {leftHeadingBlock}
            </div>
            <div className='col-sm-6'>
              {/* <ol className='breadcrumb float-sm-right'>
                <Link to='/' className='breadcrumb-item'>
                  Trang chủ
                </Link>
                <li className='breadcrumb-item active'>{title}</li>
              </ol> */}
              {rightHeadingBlock}
            </div>
          </div>
        </div>
      </section>

      {/* Main content */}
      <section className='content'>
        <div className='container-fluid'>
          {children}
          <div className='footer-action h-pb-16'>{footerBlock}</div>
        </div>
      </section>
    </div>
  );
}

export default PageWrapper;
